import React, { Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
let app = window.app;
export default function SubscriptionRow({
  data,
  blank = false,
  fields
}) {
  numeral.locale('en');
  moment.locale('fr');
  const blank_props = blank === true ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  let output = /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-title"
  }, moment(data.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-title"
  }, moment(data.end_date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-title"
  }, data.customer.lastname, ' ', data.customer.firstname), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-title"
  }, data.customer.login), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-title"
  }, data.customer?.phone_number), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-status"
  }, !moment().isBetween(data.date, data.end_date) ? 'Expiré' : data.status === 'pending' ? "En attente de paiement" : data.status === 'paid' && moment().isBetween(data.date, data.end_date) ? 'En cours' : 'Expiré'), app.state.session?.user?.roles.includes('admin') ? /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Subscription-title"
  }, data?.source === 'offline' ? 'Offline' : 'Compte client') : undefined);
  return output;
}
